var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCctv = function SvgCctv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "m5.969 9.92 9.526-5.5a.5.5 0 0 1 .683.183l3.5 6.062a.5.5 0 0 1-.183.683l-9.526 5.5a.5.5 0 0 1-.683-.183l-3.5-6.062a.5.5 0 0 1 .183-.683m-1.683.948a2 2 0 0 1 .933-2.247l9.526-5.5a2 2 0 0 1 2.732.732l3.5 6.062a2 2 0 0 1-.732 2.732l-1.981 1.144a3.25 3.25 0 0 1-1.014 3.721v1.238h4.25a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75v-1.327a3.25 3.25 0 0 1-3.05-1.17l-1.981 1.144a2 2 0 0 1-2.413-.315l-1.865 2.222a1 1 0 0 1-1.632-.143L.737 12.857a1 1 0 0 1 .692-1.484zm9.743 5.368 2.906-1.678a1.75 1.75 0 0 1-2.906 1.678m-8.278 2.306-3.358-5.817 2.62-.462 2.449 4.242z",
    clipRule: "evenodd"
  })));
};
export default SvgCctv;